import { render, staticRenderFns } from "./LibrarySearch_Desktop.vue?vue&type=template&id=23e42b4b&scoped=true&"
import script from "./LibrarySearch_Desktop.vue?vue&type=script&lang=js&"
export * from "./LibrarySearch_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./LibrarySearch_Desktop.vue?vue&type=style&index=0&id=23e42b4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e42b4b",
  null
  
)

export default component.exports